import { useEffect, useState } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseSupplierOrder } from "./UseSupplierOrder";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import SearchComProduct from "../../products/relatedProduct/SearchComProduct";
import SupplierSearchCom from "../suppliers/SupplierSearchCom";

export default function AddSupplierOrder() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [order, setOrder] = useState();
  const { validate, addOrder } = UseSupplierOrder();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    productID: undefined,
    expiredate: undefined,
    productCount: undefined,
    description: undefined,
  });

  const [errorState, setErrorState] = useState({
    productID: false,
    productCount: false,
    supplierID: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/supplierorders" },
          { name: "سفارش جدید", url: "/supplierorders/addOrder" },
        ],
      }}
    >
      {!order ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <SearchComProduct
              supplierOrder
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
              errorState={errorState.productID}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}

          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              fullWidth
              value={state.productCount ? state.productCount : ""}
              error={errorState.productCount}
              label="تعداد درخواست"
              size="small"
              type="number"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, productCount: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: { direction: "rtl" },
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <SupplierSearchCom
              setState={setState}
              state={state}
              selectedContractID={state.supplierID}
              errorState={errorState.supplierID}
              onSelect={(contract) =>
                setState({ ...state, supplierID: contract })
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              label="توضیحات"
              multiline
              rows={3}
              fullWidth
              value={state.description ? state.description : ""}
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              size="small"
              variant="outlined"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end" }}
            gridColumn="span 3"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  addOrder(state, () => {
                    setMsGotoLast(true);
                    navigate("/supplierorders", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/supplierorders", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
